import { StreamData } from './types';

type Key = string | number;

interface Storage<T> {
    has: (key: Key) => boolean;
    get: (key: Key) => T;
    set: (key: Key, value: T) => void;
}

class MapLikeObject<T> implements Storage<T> {
    private storage: Record<Key, T>;

    constructor() {
        this.storage = {};
    }

    has(key: Key) {
        return this.storage[key] !== undefined;
    }

    get(key: Key) {
        return this.storage[key];
    }

    set(key: Key, data: T) {
        this.storage[key] = data;
    }
}

export default class MediaServiceCache {
    constructor(private storage = new MapLikeObject<StreamData>()) {}

    getVideoStreamForMatch(matchId: number) {
        return this.storage.get(matchId);
    }

    hasVideoStreamForMatch(matchId: number) {
        return this.storage.has(matchId);
    }

    storeVideoStreamForMatch(matchId: number, data: StreamData) {
        return this.storage.set(matchId, data);
    }
}
